import { KEYBOARD_KEYS } from 'shared/ui/types'



const MAX_LISTBOX_HEIGHT = 300
const MARGIN = 6

/**
 * Normalizes a value to an array format
 */
export const normalizeToArray = (
  value: string | string[] | [],
  multiple: boolean
): string[] => {
  if (multiple) {
    return Array.isArray(value) ? value : []
  }

  return value && typeof value === 'string' ? [value] : []
}

export const isActivationKey = (key: string): boolean => {
  return key === KEYBOARD_KEYS.ENTER || key === KEYBOARD_KEYS.SPACE
}

export const isEscapeKey = (key: string): boolean => {
  return key === KEYBOARD_KEYS.ESCAPE
}

export const isNavigationKey = (key: string): boolean => {
  return (
    key === KEYBOARD_KEYS.ARROW_DOWN ||
    key === KEYBOARD_KEYS.ARROW_UP ||
    key === KEYBOARD_KEYS.HOME ||
    key === KEYBOARD_KEYS.END
  )
}


export const getListboxPosition = (anchorRef: React.RefObject<HTMLButtonElement | null>, listboxWrapperRef: React.RefObject<HTMLDivElement | null>) => {
  if (!anchorRef.current || !listboxWrapperRef.current) return null

  const rect = anchorRef.current.getBoundingClientRect()
  const listboxRect = listboxWrapperRef.current.getBoundingClientRect()

  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  const width = listboxRect.width
  const height = listboxRect.height

  // Determine actual listbox height (capped at MAX_LISTBOX_HEIGHT)
  const listboxHeight = Math.min(height, MAX_LISTBOX_HEIGHT)

  // Default: position below the anchor
  let top = rect.bottom + MARGIN

  // Ensure listbox is within viewport
  top = Math.max(top, MARGIN)
  top = Math.min(top, viewportHeight - listboxHeight - MARGIN)

  // Horizontal positioning: center to anchor
  let left = rect.left + (rect.width - width) / 2

  left = Math.max(left, MARGIN)
  left = Math.min(left, viewportWidth - width - MARGIN)

  return { top, left }
}
